import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component
({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})

export class AlertDialogComponent implements OnInit
{
  public showCancel:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, detail:string, accept:string, cancel:string}) { }

  ngOnInit(): void 
  {
    this.showCancel = this.data.cancel !== undefined;
  }
}